import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIVAPostingGroup } from "src/models/General/IVAPostingGroup.models";

interface IVAPostingGroupState {
  ivaPostingGroups: IIVAPostingGroup[];
  ivaPostingGroupToEdit: IIVAPostingGroup | null;
}

const initialState: IVAPostingGroupState = {
  ivaPostingGroups: [],
  ivaPostingGroupToEdit: null,
};

const ivaPostingGroupSlice = createSlice({
  name: "IVAPostingGroup",
  initialState,
  reducers: {
    setIVAPostingGroupList: (
      state,
      action: PayloadAction<IIVAPostingGroup[]>
    ) => {
      state.ivaPostingGroups = action.payload;
    },
    concatListIVAPostingGroup: (
      state: IVAPostingGroupState,
      action: PayloadAction<IIVAPostingGroup[]>
    ) => {
      state.ivaPostingGroups = [
        ...state.ivaPostingGroups.concat(action.payload),
      ];
    },
    setIVAPostingGroupToEdit: (
      state,
      action: PayloadAction<IIVAPostingGroup | null>
    ) => {
      state.ivaPostingGroupToEdit = action.payload;
    },
    addIVAPostingGroup: (state, action: PayloadAction<IIVAPostingGroup>) => {
      state.ivaPostingGroups.push(action.payload);
    },
    updateIVAPostingGroup: (state, action: PayloadAction<IIVAPostingGroup>) => {
      let itemIndex = state.ivaPostingGroups.findIndex(
        item =>
          item.generalIVAPostingGroupId ===
          action.payload.generalIVAPostingGroupId
      );
      if (itemIndex !== -1) state.ivaPostingGroups[itemIndex] = action.payload;
    },
    deleteIVAPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.ivaPostingGroups.filter(
        item => item.generalIVAPostingGroupId !== action.payload
      );
      state.ivaPostingGroups = newArray;
    },
  },
});

export const {
  setIVAPostingGroupList,
  concatListIVAPostingGroup,
  setIVAPostingGroupToEdit,
  addIVAPostingGroup,
  updateIVAPostingGroup,
  deleteIVAPostingGroup,
} = ivaPostingGroupSlice.actions;

export default ivaPostingGroupSlice.reducer;
